"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const AbstractDropdownWidget_1 = tslib_1.__importDefault(require("../AbstractDropdownWidget"));
class UngroupedDropdownWidget extends AbstractDropdownWidget_1.default {
    constructor(args) {
        super({ ...args });
        this.element.classList.add("ungrouped-dropdown");
    }
    setOptions(options = [], fireEvents = false) {
        this.options = [];
        this.optionElements = [];
        this.optionToLiMap.clear();
        this.optionLiToIndexMap.clear();
        this.currentLiHighlighted = undefined;
        // Clear suggestions
        while (this.dropdownList.firstChild) {
            this.dropdownList.removeChild(this.dropdownList.firstChild);
        }
        const noOptionText = this.model.getTextForNoOptionSelected();
        if (noOptionText) {
            const noOptionLi = this.createEmptyOptionLiElement(noOptionText);
            this.dropdownList.appendChild(noOptionLi);
        }
        options.forEach((option, index) => {
            const optionLiElement = this.createOptionLIElement({ option });
            this.optionToLiMap.set(option, optionLiElement);
            this.optionLiToIndexMap.set(optionLiElement, index);
            this.optionElements.push(optionLiElement);
            this.options.push(option);
            this.dropdownList.appendChild(optionLiElement);
        });
        this.setPlaceholder(this.options.length === 0 ? this.noOptionsPlaceholder : this.regularPlaceholder);
        if (this.options.length === 1 && this.shouldSelectIfSingleOption) {
            this.setValue(this.options[0], fireEvents);
        }
        else {
            this.setValue(null, fireEvents);
        }
    }
    setUnknownValue(newValue, fireEvents) {
        if (!this.options.includes(newValue)) {
            const optionLiElement = this.createOptionLIElement({ option: newValue, isUnknownOption: true });
            this.optionToLiMap.set(newValue, optionLiElement);
            this.optionLiToIndexMap.set(optionLiElement, this.optionElements.length);
            this.optionElements.push(optionLiElement);
            this.options.push(newValue);
            this.dropdownList.appendChild(optionLiElement);
        }
        this.setValue(newValue);
    }
    decorateAbstractDropdownElement(args) {
        this.decorateUngroupedDropdownElement(args);
    }
}
exports.default = UngroupedDropdownWidget;
//# sourceMappingURL=UngroupedDropdownWidget.js.map